<template>
  <BaseLayout page-default-back-link="/nativeTab/case" pageTitle="案件详情" :showFooter="true">
    <div class="case-details">
      <div class="lawyer-info">
        <div class="f-y-center">
          <img class="avatarImage m-r-10" :src="jz1Image" />
          <div class="font-lg">云文虹律师负责该案件</div>
        </div>
        <div class="f-y-center">
          <img class="phoneImage m-r-10" src="@/assets/phone.png" />
          <div class="font">联系律师</div>
        </div>
      </div>
      <div class="f-center p-t-30 p-b-30 segment">
        <div class="segment-box">
          <ion-segment value="1">
            <ion-segment-button @click="segmentValue = '1'" value="1">
              <div class="font-lg">服务进程</div>
            </ion-segment-button>
            <ion-segment-button @click="segmentValue = '2'" value="2">
              <div class="font-lg">案件通告</div>
            </ion-segment-button>
          </ion-segment>
        </div>
      </div>
      <div class="f-1 w-100b">
        <div v-if="segmentValue == '1'" class="schedule p-t-40 p-b-40">
          <ScheduleItem
            v-for="(item, index) in schedules"
            :key="index"
            :state="item.state"
            :title="item.title"
            :time="item.time"
            :hideBorder="index == schedules.length - 1"
          />
        </div>
        <div v-if="segmentValue == '2'" class="schedule p-t-40">
          <NewsDetailsListItem
            v-for="(item, index) in newsData"
            :key="index"
            :title="item.title"
            :time="item.time"
            :content="item.content"
            :file="item.file"
          />
        </div>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import { ref, reactive } from 'vue'
import { ScheduleItem } from '@/view/case/components'
import { DetailsListItem as NewsDetailsListItem } from '@/view/news/components'
import jz1Image from '@/assets/jz/1.png'

export default {
  setup(props, { emit }) {
    const segmentValue = ref('1')

    const segmentChanged = (value) => {
      segmentValue.value = value
    }
    const schedules = [
      {
        state: 3,
        title: '民事起诉状',
        time: '2021.08.07 10:32',
      },
      {
        state: 3,
        title: '法院立案',
        time: '2021.08.07 10:32',
      },
      {
        state: 3,
        title: '诉讼文书送达',
        time: '2021.08.07 10:32',
      },
      {
        state: 3,
        title: '诉讼保全',
        time: '2021.08.07 10:32',
      },
      {
        state: 2,
        title: '举证期限届满前的法律审查',
        time: '2021.08.07 10:32',
      },
      {
        state: 1,
        title: '证据目录举证清单',
        time: '2021.08.07 10:32',
      },
      {
        state: 1,
        title: '证据交换与质证',
        time: '2021.08.07 10:32',
      },
      {
        state: 1,
        title: '回避申请',
        time: '2021.08.07 10:32',
      },
      {
        state: 1,
        title: '庭前通知',
        time: '2021.08.07 10:32',
      },
      {
        state: 1,
        title: '一审庭审',
        time: '2021.08.07 10:32',
      },
      {
        state: 1,
        title: '是否撤诉',
        time: '2021.08.07 10:32',
      },
      {
        state: 1,
        title: '律师代理词（意见）模块',
        time: '2021.08.07 10:32',
      },
      {
        state: 1,
        title: '裁判文书审查和送达模块',
        time: '2021.08.07 10:32',
      },
      {
        state: 1,
        title: '结案',
        time: '2021.08.07 10:32',
      },
    ]
    const newsData = ref([
      {
        title: '龙建与刘必仁、许滇音民间借贷纠纷一',
        time: '2021.08.10 10:40',
        content:
          '再审申请人龙建因与被申请人刘必仁、许滇音及一审被告、二审上诉人上海吉仕纸品有限公司(以下简称吉仕公司)民间借贷纠纷一案',
        file: [
          // 'https://avatars2.githubusercontent.com/u/20411648?s=460&v=4',
          // 'https://avatars2.githubusercontent.com/u/20411648?s=460&v=4',
          // 'https://avatars2.githubusercontent.com/u/20411648?s=460&v=4',
        ],
      },
      {
        title: '龙建与刘必仁、许滇音民间借贷纠纷一案',
        time: '2021.08.10 10:40',
        content:
          '龙建申请再审称：本案借款是吉仕公司的债务，不是龙建的个人债务，原审判决龙建承担共同还款责任适用法律错误。龙建在担任吉仕公司的法定代表人期间在',
        file: [
          // 'https://avatars2.githubusercontent.com/u/20411648?s=460&v=4',
          // 'https://avatars2.githubusercontent.com/u/20411648?s=460&v=4',
          // 'https://avatars2.githubusercontent.com/u/20411648?s=460&v=4',
        ],
      },
      {
        title: '龙建与刘必仁、许滇音民间借贷纠纷一',
        time: '2021.08.10 10:40',
        content:
          '再审申请人龙建因与被申请人刘必仁、许滇音及一审被告、二审上诉人上海吉仕纸品有限公司(以下简称吉仕公司)民间借贷纠纷一案...',
        file: [
          // 'https://avatars2.githubusercontent.com/u/20411648?s=460&v=4',
          // 'https://avatars2.githubusercontent.com/u/20411648?s=460&v=4',
          // 'https://avatars2.githubusercontent.com/u/20411648?s=460&v=4',
        ],
      },
    ])
    return { segmentValue, schedules, newsData, jz1Image }
  },
  components: { ScheduleItem, NewsDetailsListItem },
}
</script>

<style lang="scss">
.case-details {
  display: flex;
  flex-direction: column;
  background: linear-gradient(0deg, #f5f8ff 0%, #ffffff 100%);
  .avatarImage {
    width: 70px;
    height: 70px;
    border-radius: 50%;
  }

  .lawyer-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 114px;
    padding: 0 40px 0;
  }
  .segment {
    // background-color: #f6f7fa;

    ion-segment-button {
      // --indicator-color: #3370ff;
      // --border-radius: 33px;
      // --indicator-height: 66px;
      // --color: #fff;
    }
  }
}
</style>